import React from 'react';
import { translate } from 'admin-on-rest';
import MoneyIcon from 'material-ui/svg-icons/editor/attach-money';

const BRAND_BLUE = '#284263';

const styles = {
    card:    { background: '#fff', borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)', overflow: 'hidden' },
    header:  { padding: '12px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    title:   { fontSize: 13, fontWeight: 700, color: '#111827', letterSpacing: 0.2, display: 'flex', alignItems: 'center', gap: 8 },
    badge:   { fontSize: 11, color: '#6b7280', background: '#f3f4f6', padding: '2px 8px', borderRadius: 999, fontWeight: 600 },
    listWrap:{ maxHeight: 360, overflowY: 'auto' },
    row:     { display: 'grid', gridTemplateColumns: '70px 1fr 70px', gap: 8, alignItems: 'center', padding: '8px 16px', borderBottom: '1px solid #f9fafb', fontSize: 12 },
    date:    { fontSize: 11, color: '#9ca3af' },
    company: { fontWeight: 600, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    site:    { fontSize: 11, color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    bid:     { fontWeight: 700, color: BRAND_BLUE, textAlign: 'right', fontVariantNumeric: 'tabular-nums' },
    empty:   { padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 12 },
};

const fmtEur = (n) => `€ ${Number(n || 0).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default translate(({ bids = [], nb }) => (
    <div style={styles.card}>
        <div style={styles.header}>
            <span style={styles.title}>
                <MoneyIcon style={{ width: 14, height: 14, color: BRAND_BLUE }} />
                {nb}
            </span>
            <span style={styles.badge}>{bids.length}</span>
        </div>
        <div style={styles.listWrap}>
            {bids.length === 0 && <div style={styles.empty}>Geen recente wijzigingen</div>}
            {bids.map((record) => (
                <div key={record.id} style={styles.row}>
                    <span style={styles.date}>{new Date(record.started_on).toLocaleDateString('nl-NL')}</span>
                    <div>
                        <div style={styles.company}>{record.company_name}</div>
                        <div style={styles.site}>{record.website_url}</div>
                    </div>
                    <span style={styles.bid}>{fmtEur(record.bid)}</span>
                </div>
            ))}
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/dashboard/LatestBidsList.js